module.exports = __webpack_public_path__ + "static/media/firstlithoniamenshealth.1b7a8e86.jpg";